import * as Api from '@ViewModels';
import { useEffect, useState } from 'react';
import { useEmailLikeStepState } from './useEmailLikeStepState';

interface UseAIEmailStepStateProps {
	aiEmailStep: Api.IAIEmailAutomationStep | null;
	template: Api.IAutomationTemplate | null;
	stepId: string;
	readonly: boolean;
	onSaveSuccess?: () => void;
	onSaveError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * State management hook for AIEmailStepRenderer.
 *
 * Extends the shared email-like state with the prompt, which is the only content
 * an author supplies for this step type.
 */
export function useAIEmailStepState({
	aiEmailStep,
	template,
	stepId,
	readonly,
	onSaveSuccess,
	onSaveError,
}: UseAIEmailStepStateProps) {
	const [prompt, setPrompt] = useState(aiEmailStep?.prompt || '');

	useEffect(() => {
		setPrompt(aiEmailStep?.prompt || '');
	}, [aiEmailStep?.prompt]);

	const emailLikeState = useEmailLikeStepState({
		step: aiEmailStep as (Api.IEmailAutomationStep & Api.IHtmlNewsletterAutomationStep) | null,
		template,
		stepId,
		readonly,
		onSaveSuccess,
		onSaveError,
	});

	return {
		...emailLikeState,
		prompt,
		setPrompt,
	};
}
